import { END_POINT } from '../end-point';
import { httpService } from '../util/axiosRequests';
import { getAccessTokenFromCookies } from 'lib/utils/setTokensInCookies';

const fileAPI = {
  // 파일 다운로드 API
  async downloadFile(fileName: string): Promise<void> {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response: any = await httpService.get(END_POINT.fileController.getDownload(encodeURIComponent(fileName)), {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        },
        responseType: 'blob' // 파일 데이터는 바이너리(blob) 형태로 응답
      });

      // 파일 다운로드를 위한 Blob 객체 생성
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      // Blob URL 생성
      const url = window.URL.createObjectURL(blob);
      // 숨겨진 링크 요소 생성
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName); // 파일 이름 설정
      document.body.appendChild(link);
      link.click();
      // 다운로드 후 링크 요소 제거
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('downloadFile 실패 :', error);
      throw error;
    }
  }
};

export const { downloadFile } = fileAPI;
